import { load, store } from "./localStorage"
import { getGA4SessionId } from "./utils"

const KGS_IN_LBS = 0.453592
const LBS_IN_KG = 2.20462
const INCH_IN_CM = 2.54
const CM_IN_FT = 30.48

const round = Math.round
export const kgToLbs = (kg) => kg / KGS_IN_LBS
export const lbsToKg = (lbs) => lbs / LBS_IN_KG
export const cmToFtIn = (cm) => {
  const totalInch = cm / INCH_IN_CM
  const feet = Math.floor(totalInch / 12)
  const inch = totalInch - 12 * feet

  return { heightFt: Math.round(feet), heightIn: Math.round(inch) }
}

export const ftInToCm = ({ ft, inch }) => {
  const heightCm = Math.round(ft * CM_IN_FT + inch * INCH_IN_CM)

  return heightCm
}

function initialState() {
  return {
    // Globals
    token: null,
    measurementSystem: "metric",
    domain: null,
    goal: "Lose weight",
    cookiesAgreed: null,
    marketingAgreed: null,
    // Step 01-test
    mainGoal: null,
    // Step 02-test
    sixMonthsWeightLoss: null,
    // Step 03-test
    privacyAgreement: null,
    termsOfService: null,
    // Step 04-test
    firstName: null,
    // Step 05-test
    gender: null,
    // Step 06-test
    heightCm: null,
    heightFt: null,
    heightIn: null,
    // Step 06-test
    weightKg: null,
    weightLbs: null,
    // Step 07
    targetWeightKg: null,
    targetWeightLbs: null,
    // Step 08
    age: null,
    // Step 10
    feelingHungryPeriod: null,
    // Step 11
    betterAppetitePeriod: null,
    // Step 12
    snackHungryOption: null,
    // Step 13
    snackStressOption: null,
    // Step 14
    smokingAtLeastFiveCigaretesPerWeek: null,
    // Step 15
    smokingAtLeastTwentyCigaretesPerMonth: null,
    // Step 16
    averageSleepingTime: null,
    // Step 17
    bloatingExperienceOccurence: null,
    // Step 18
    bloatingExperiencePeriod: null,
    // Step 19
    hormonalMedicinesUsage: null,
    // Step 20
    antiDepresantsUsage: null,
    // Step 21
    foodSuplementsOrVitaminsUsage: null,
    // Step 22
    chronicOrAcuteDisease: [],
    // Step 23
    healthComplaints: [],
    // Step 24
    beefEatingOccurence: null,
    // Step 25
    haveInfants: null,
    // Step 26
    allergies: [],
    // Step 27
    weightLossAttemptsInLast12Months: null,
    // Step 28
    appetiteChangeInLast30Days: null,
    // Step 29
    hungryFeelingAfterMealPeriod: null,
    // Step 30
    feelingSleepyAfterMealOccurence: null,
    // Step 31
    shopingForFoodPeriod: null,
    // Step 32
    restaurantOrderingHabits: null,
    // Step 33
    firstMealTime: null,
    // Step 34
    overeatPeriod: null,
    // Step 35
    cookingHabits: null,
    // Step 36
    mealPreparingAvgTime: null,
    // Step 37
    fishEatingMeal: null,
    // Step 38
    eggsPerWeek: null,
    // Step 39
    vegetablesPerDay: null,
    // Step 40
    amountOfWaterDuringMeal: null,
    // Step 41
    waterIntakeAmount: null,
    // Step 42
    coffeeIntakeAmount: null,
    // Step 43
    averageWorkingDay: null,
    // Step 44
    snackOfChoiceInLast30Days: null,
    // Step 45
    eatingHabitsDifferentDuringWeekend: null,
    // Step 46
    cookingForSomeoneElse: null,
    // Step 47
    eatingPlace: null,
    // Step 48
    hardLiquorAmount: null,
    // Step 49
    lightAlcoholAmount: null,
    // Step 50
    workingOutOccurence: null,
    // Step 51
    walkingOccurence: null,
    // Step 52
    feelingDuringPhysicalActivities: null,
    // Step 53
    bodyParts: [],
    // Step 54
    motivationForLosingWeight: null,
    // Step 55
    overWeightCausedProblems: null,
    // Step 56
    weightLossCelebrate: null,
    // Step 58
    email: null,

    //Step 61-checkout
    paymentPrice: null,

    isAbandonedBasketOrigin: false,
    exitIntent: false,
    paymentMethod: null,
    paymentSuccessUrl: null,
    paymentFailUrl: null,
    paymentUrl: null, // comes from backend when paymentMethod is set
  }
}

const LOCAL_STORAGE_KEY = "data"

export default {
  init() {
    this.values = initialState()

    const data = load(LOCAL_STORAGE_KEY)

    if (data?.values) {
      this.values = data.values
    }

    Alpine.effect(() => {
      this.writeToLocalStorage()
    })
  },

  // Push data store to backend API
  async push() {
    const additionalData = {}

    additionalData.domain = document.location.host

    // Add cookies - _ga, _gid, _fbc, _fbp, ...
    document.cookie.split("; ").forEach((item) => {
      const [key, value] = item.split("=")
      additionalData[key] = value
    })

    // Add search params - fbclid, utm_*, ...
    const url = new URL(document.location)
    url.searchParams.forEach((value, key) => {
      additionalData[key] = value
    })

    // console.log("Push order")
    const apiUrl = pipelineConfig.orderApiUrl
    const options = {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        ...this.values,
        ...additionalData,
      }),
    }

    if (this.values.token) {
      options.method = "PATCH"
      options.headers["x-token"] = this.values.token
    }

    try {
      const res = await fetch(apiUrl, options)
      const data = await res.json()

      if (res.ok) {
        this.error = undefined

        Object.entries(data).forEach(([key, value]) => {
          this.values[key] = value
        })
      } else {
        this.error = data.error
      }
    } catch (error) {
      this.error = error
    }

    return !this.error
  },

  writeToLocalStorage() {
    store(LOCAL_STORAGE_KEY, { values: this.values })
  },

  // Fetch data from backend API
  async pull() {
    if (this.values.token) {
      const res = await fetch(pipelineConfig.orderApiUrl, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          "x-token": this.values.token,
        },
      })
      const data = await res.json()
      Object.entries(data).forEach(([key, value]) => {
        this.values[key] = value
      })

      this.writeToLocalStorage({
        ...data,
        exitIntent: true,
        isAbandonedBasketOrigin: true,
      })
    }
  },

  goBack() {
    history.back()
  },

  redirect(page) {
    if (!page) return

    window.location.pathname = page
  },

  setMeasurementSystem(value) {
    if (!value) return

    this.values.measurementSystem = value
  },

  setMainGoal(goal, href) {
    this.values.mainGoal = goal

    this.redirect(href)
  },

  setSixMonthsWeightLoss(sixMonthsWeightLoss, href) {
    this.values.sixMonthsWeightLoss = sixMonthsWeightLoss

    this.redirect(href)
  },

  setGender(value) {
    this.values.gender = value
  },

  get normalizedHeight() {
    if (this.isMetric) {
      return this.values.heightCm
    } else {
      return this.values.heightFt * 30.48 + this.values.heightIn * 2.54
    }
  },

  get normalizedWeight() {
    if (this.isMetric) {
      return this.values.weightKg
    } else {
      return this.values.weightLbs * KGS_IN_LBS
    }
  },

  get isFemale() {
    return this.values.gender === "female"
  },

  get isMale() {
    return this.values.gender === "male"
  },

  get weightUnits() {
    return this.isMetric ? "kg" : "lbs"
  },

  get isMetric() {
    return this.values.measurementSystem === "metric"
  },

  get isImperial() {
    return this.values.measurementSystem === "imperial"
  },

  get loseWeight() {
    return this.values.goal === "Lose weight"
  },

  get bmi() {
    return this.normalizedWeight / (this.normalizedHeight / 100.0) ** 2
  },

  overWeight() {
    return this.isMetric
      ? this.values.weightKg - this.values.targetWeightKg
      : this.values.weightLbs - this.values.targetWeightLbs
  },

  formattedOverWeight() {
    return this.formatWeight(this.overWeight())
  },

  get idealWeight() {
    return round((this.normalizedHeight ** 2 * 21.1) / 10000)
  },

  get idealWeightRange() {
    const minBMI = 18.5
    const maxBMI = 27
    const normalizedHeightM = this.normalizedHeight / 100.0
    const lowestWeightValue = this.isImperial ? round(kgToLbs(30)) : 30
    const currentWeight = this.isImperial ? this.values.weightLbs : this.values.weightKg

    let min = minBMI * Math.pow(normalizedHeightM, 2)
    let max = Math.min(normalizedHeightM ** 2 * maxBMI, this.normalizedWeight - 1)

    if (this.isImperial) {
      min = kgToLbs(min)
      max = kgToLbs(max)
    }

    min = Math.max(round(min), lowestWeightValue)
    max = Math.max(round(max), lowestWeightValue)

    if (min >= currentWeight) {
      max = Math.max(...[currentWeight - 1, lowestWeightValue])
      min = Math.max(...[currentWeight - 2, lowestWeightValue])
    }

    return Array.from({ length: max - min + 1 }, (_, i) => i + min)
  },

  get idealWeightRangeOptions() {
    const idealRange = this.idealWeightRange
    const options = idealRange.map((val) => ({
      title: `${val}`,
      value: `${val}`,
    }))

    return options
  },

  formattedHeight() {
    const { heightCm, heightFt, heightIn } = this.values

    if (this.isImperial) {
      return `${heightFt}ft ${heightIn}in`
    } else {
      return `${heightCm}cm`
    }
  },

  formatWeight(value) {
    return `${value}${this.weightUnits}`
  },

  formattedWeight() {
    return this.formatWeight(this.isMetric ? this.values.weightKg : this.values.weightLbs)
  },

  formattedIdealWeight() {
    return this.formatWeight(this.isMetric ? this.idealWeight : round(kgToLbs(this.idealWeight)))
  },

  formattedMinIdealWeight() {
    return this.formatWeight(this.idealWeightRange[0])
  },

  formattedMaxIdealWeight() {
    return this.formatWeight(this.idealWeightRange.slice(-1)[0])
  },

  formattedWeightToLose() {
    const { weightKg, targetWeightKg, weightLbs, targetWeightLbs } = this.values

    return this.formatWeight(
      this.isMetric ? weightKg - targetWeightKg : weightLbs - targetWeightLbs
    )
  },

  formattedWeightGoal() {
    return this.formatWeight(
      this.isMetric ? this.values.targetWeightKg : this.values.targetWeightLbs
    )
  },

  async pay(options) {
    this.values.paymentMethod = options.paymentMethod
    this.values.paymentSuccessUrl = options.paymentSuccessUrl
    this.values.paymentFailUrl = options.paymentFailUrl

    if (await this.push()) {
      window.location = this.values.paymentUrl
    }
  },

  async initiateCheckout(invoiceIdentifier, checkout, paymentSuccessUrl, paymentFailUrl) {
    this.values.invoiceIdentifier = invoiceIdentifier
    this.values.initiateCheckoutAt = new Date()
    this.values.paymentSuccessUrl = paymentSuccessUrl
    this.values.paymentFailUrl = paymentFailUrl
    this.values.checkout = checkout

    await this.push()
  },

  async completePayment() {
    this.values.completedAt = new Date()

    await this.push()
  },

  goToLogin() {
    const loginUrl =
      pipelineConfig.loginUrl + `/direct_login/${this.values.userId}/${this.values.userToken}`
    this.values = initialState()
    window.top.location.href = loginUrl || pipelineConfig.loginUrl
  },

  get enabledDiscount() {
    return this.values.exitIntent
  },

  async enableDiscount(nextStepPath) {
    this.values.exitIntent = true

    if (await this.push()) {
      window.location = nextStepPath
    }
  },

  async setIsAbandonedBasketOrigin() {
    this.values.isAbandonedBasketOrigin = true
    this.values.exitIntent = true

    await this.push()
  },

  getPipelineID() {
    const url = pipelineConfig.orderApiUrl
    const pipelinesMatchedString = url.match(/pipelines\/+\d+\//) // atrod 'pipelines/71/'

    return pipelinesMatchedString[0].split("/")[1] // atrod 'pipelines , 71' un tu paņem 71
  },

  async createStripePayment(successUrl, failUrl) {
    window.addEventListener(
      "message",
      async (event) => {
        if (event.origin !== pipelineConfig.productApiUrl) return
        if (!event.data) return

        const data = JSON.parse(event.data)

        if (data.redirect === successUrl) {
          this.values.failedPayment = false
          this.values.completedAt = new Date()
          await this.push()
        } else if (data.redirect === failUrl) {
          this.values.failedPayment = true
          await this.push()
        }

        window.location = data.redirect
      },
      false
    )

    const { userId, userToken, utm_campaign, utm_content, utm_medium, utm_source, _ga, utm_term } =
      this.values

    const paymodeId = pipelineConfig.productApiUrl.includes("stockholmdiet.com") ? 18 : 13
    const apiUrl = `${pipelineConfig.productApiUrl}/pay/checkout/${pipelineConfig.productOfferId}/${userId}/${paymodeId}`

    if (userId) {
      const res = await fetch(apiUrl, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: userToken,
        },
        method: "POST",
        body: JSON.stringify({
          chance: this.enabledDiscount,
          origin_id: this.values.id,
          origin_host: `https://${this.values.domain}`,
          origin_path: pipelineConfig.pathPrefix,
          successful_payment_path: successUrl,
          failed_payment_path: failUrl,
          utm_source: utm_source || "",
          utm_medium: utm_medium || "",
          utm_campaign: utm_campaign || "",
          utm_term: utm_term || "",
          utm_content: utm_content || "",
          custom_post_payment: true,
          initiated_remotely: true,
          external_sync: true,
          ga_session_id: getGA4SessionId(),
          ga_cid: _ga?.match(/[^\.]+\.[^\.]+$/)?.[0] || "",
          pipelineId: this.getPipelineID(),
        }),
      })
      const data = await res.json()
      this.values.checkout = data
      this.values.invoiceIdentifier = data.invoice.identifier
      this.values.initiateCheckoutAt = new Date()
      this.values.paymentSuccessUrl = successUrl
      this.values.paymentFailUrl = failUrl
      this.stripeUrl = data.url + "/sd-r-series"

      this.push()
    }
  },

  async trackVisitCheckout() {
    this.values.status = "VISIT_CHECKOUT"
    await this.push()
  },
}
